import {Component} from '@angular/core';
import {Color, Label} from 'ng2-charts';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {ReporteServices} from '../../services/reporte.services';
import {CurrencyPipe} from '@angular/common';
import {forkJoin} from 'rxjs';
import {DevolverColorFriedman} from './ventas.widget.component';

@Component({
  selector: 'ventas-comparativo-widget',
  templateUrl: '../../templates/widgets/ventas.comparativo.widget.template.html'
})
export class VentasComparativoWidgetComponent {
  public mostrar: boolean = false;
  public datosGrafica: any[] = [];

  public barChartLabels: Label[] = [];

  public barChartData: ChartDataSets[] = [
    {data: [], label: '', type: 'line', fill: false, backgroundColor: 'rgba(0,0,0,0)'},
    {data: [], fill: false, label: 'Cumplimiento'},
    {data: [], fill: false, label: 'Cumplimiento'}

  ];

  public barChartColors: Color[] = [];
  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {xAxes: [{}], yAxes: [{}]},
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        formatter: (value, ctx) => {

          const label = ctx.chart.data.datasets[0].data[ctx.dataIndex] + '%';
          // console.log(ctx.chart.data);
          return label;
        },
        font: {
          size: 0
        }
      }
    }
  };

  public barChartType: ChartType = 'bar';
  public barChartLegend = true;

  constructor(private rs: ReporteServices, private cp: CurrencyPipe) {
  }

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string, fecha3: string, fecha4: string) {
    this.mostrar = false;
    this.barChartLabels = [];

    let valoresGrafica1 = [];
    let valoresGrafica2 = [];
    let valoresCum = [];
    let coloresBarra1: any[] = [];
    let coloresBarra2: any[] = [];

    let consultas: any[] = [];
    consultas.push(this.rs.devolverReporteVentas(entidad, idEntidad, fecha1, fecha2));
    consultas.push(this.rs.devolverReporteVentas(entidad, idEntidad, fecha3, fecha4));

    forkJoin(consultas).subscribe((d:any) => {
      console.log(d);
      let data1 = JSON.parse(d[0].data.reporteVentas);
      let data2 = JSON.parse(d[1].data.reporteVentas);

      for(let inf1 of data1.infMetaPar){
        let cumplimiento:number = 0;
        if(inf1.meta > 0)
          cumplimiento = inf1.ventas/inf1.meta * 100;

        this.barChartLabels.push(inf1.nombres);

        cumplimiento = parseFloat(cumplimiento.toFixed(2));
        valoresGrafica1.push(cumplimiento);
        coloresBarra1.push(DevolverColorFriedman(cumplimiento));
        valoresCum.push(100);
      }

      this.barChartData[1].data = valoresGrafica1;
      this.barChartData[1].backgroundColor = [...coloresBarra1];

      for(let inf2 of data2.infMetaPar){
        let cumplimiento:number = 0;
        if(inf2.meta > 0)
          cumplimiento = inf2.ventas/inf2.meta * 100;

        if(!this.barChartLabels.find(l=> l == inf2.nombres)) {
          this.barChartLabels.push(inf2.nombres);
          valoresCum.push(100);
        }

        cumplimiento = parseFloat(cumplimiento.toFixed(2));
        valoresGrafica2.push(cumplimiento);
        coloresBarra2.push(DevolverColorFriedman(cumplimiento));

      }

      this.barChartData[2].data = valoresGrafica2;
      this.barChartData[2].backgroundColor = [...coloresBarra2];

      this.barChartData[0].data = valoresCum;
      this.mostrar = true;


    });


  }

}
